import { CURRENT_LANGUAGE } from 'consts'
import { TTS_SPEECH_API_PATH } from 'consts/api'
import ApiFactory from 'services/api-factory'
import {
  IGenerateTtsItemsRequestBody,
  ITtsItemData,
  ITtsLanguageOption,
  ITtsSpeaker,
  ITtsSpeakerTone
} from 'types/text-to-speech'
import { getQueryParams, getQueryStringForArrays } from 'utils'

const TtsApi = new ApiFactory({ baseUrl: TTS_SPEECH_API_PATH })

export const getTtsLanguageOptions_API = () => {
  const queryParams = getQueryParams({
    language: CURRENT_LANGUAGE
  })
  return TtsApi.get<ITtsLanguageOption[]>(`/options?${queryParams}`)
}

export const getTtsSpeakers_API = ({ langCode }: { langCode?: string }) => {
  const queryParams = getQueryParams({
    language: CURRENT_LANGUAGE,
    langCode
  })

  return TtsApi.get<ITtsSpeaker[]>(`/voices?${queryParams}`)
}

export const getTtsSpeakerTones_API = () => {
  const queryParams = getQueryParams({
    language: CURRENT_LANGUAGE
  })

  return TtsApi.get<ITtsSpeakerTone[]>(`/tones?${queryParams}`)
}

export const getTtsItems_API = (ids: number[]) => {
  const queryString = getQueryStringForArrays('ids', ids.map(String))
  return TtsApi.get<ITtsItemData[]>(`/?${queryString}`)
}

export const generateTtsItems_API = (
  requestBody: IGenerateTtsItemsRequestBody
) => {
  return TtsApi.post<ITtsItemData, IGenerateTtsItemsRequestBody>(
    '/generate',
    requestBody
  )
}

export const regenerateTtsItem_API = (
  id: number,
  requestBody: IGenerateTtsItemsRequestBody
) => {
  return TtsApi.put<ITtsItemData, IGenerateTtsItemsRequestBody>(
    `/${id}`,
    requestBody
  )
}
